import { Injectable } from '@angular/core';
import { BBService, BBModel } from 'bookingbug-core-js';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import moment from 'moment';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AmazonService {
  private core = AppConfig.settings.core;
  private apiServer = AppConfig.settings.apiServer;
  member;

  constructor(private http: HttpClient) { }

  async osGetNameDataEncodedApi(postcode: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      return await this.http
        .get(`${environment.apiServer}/ordnance_survey/postcode/${postcode}`, {
          headers,
        })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getFormSchema(formId: string, company_id, companyName) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      const data = {
        company: company_id,
        client: `${companyName}`,
        form_name: `${formId}`,
      };
      return await this.http
        .post(`${environment.apiServer}/form/schema`, data, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async putPermitApplicationOperation(
    data: any,
    company_id,
    companyName,
    operation,
    annual_allowance,
    day_allowance,
    valid_from,
    valid_to,
    permit_id = undefined
  ) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      let body: any = {};
      body.data = data;
      body.function = operation;
      body.company = company_id;
      body.client = `${companyName}`;
      body.annual_allowance = annual_allowance;
      body['1_day_allowance'] = day_allowance;
      body.status = 2;
      body.valid_from = valid_from
      body.valid_to = valid_to
      if (permit_id) {
        body.permit_id = permit_id
      }
      return await this.http
        .put(`${environment.apiServer}/permitApplications`, body, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async checkPermitApplicationOperation(
    company_id,
    companyName,
    permit_id,
    operation,
    vehicleReg: any = '',
    email_address = '',
    contact_number = '',
    detailName = '',
    detailSubName = '',
    detailSubSubName = '',
    detailValue: any = ''
  ) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      let body: any = {};
      body.function = operation;
      body.company = company_id;
      body.permit_id = permit_id;
      body.vehicleReg = vehicleReg;
      body.email_address = email_address;
      body.contact_number = contact_number;
      body.detailName = detailName;
      body.detailSubName = detailSubName;
      body.detailSubSubName = detailSubSubName;
      body.detailValue = detailValue;
      body.client = `${companyName}`;

      return await this.http
        .put(`${environment.apiServer}/permitApplications`, body, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async updateNotificationsAuditTrail(
    company_id,
    companyName,
    permit_id,
    sendBody: any = {}
  ) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      let body: any = {};
      body.function = 'updateNotificationsAuditTrail';
      body.permit_id = permit_id;
      delete sendBody.variables
      body.sendBody = sendBody;
      body.client = `${companyName}`;

      return await this.http
        .put(`${environment.apiServer}/permitApplications`, body, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async uploadFile(file: object) {
    const headers = {
      'Content-Type': 'application/json',
      'no-loader': 'no-loader',
      clienttoken: environment.clientToken,
    };
    return await this.http
      .post(`${environment.apiServer}/upload`, file, { headers })
      .toPromise();
  }

  async emailTemplateSender(commsData: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };

      return await this.http
        .post(`${environment.apiServer}/emailTemplateSender`, commsData, {
          headers,
        })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async getBooking(company_id: number, bookingid: number) {

    try {
      const headers = {
        'Content-Type': 'application/json',
        'x-company-id': `${company_id}`
      };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/booking/${bookingid}`, { headers }).toPromise();
    } catch (error) {
      console.log(error);
      return (error as Error).message;
    }
  }


  async getServices(company_id: number, nounspinnpass = false) {
    try {
      const headers: any = { 'Content-Type': 'application/json' };
      if (nounspinnpass) {
        headers.nounspinnpass = 'true'
      }
      return await this.http.get(`${environment.apiServer}/company/${company_id}/services`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getService(company_id: number, service_id: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${company_id}/service/${service_id}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getCompany(companyid: any) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${companyid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getMemberDetails(companyId: any, uid: string) {

    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/client/${uid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getPurchase(companyId: number, serviceId: number, purchaseId: number) {
    try {
      const headers = { 'Content-Type': 'application/json' };
      return await this.http.get(`${environment.apiServer}/company/${companyId}/service/${serviceId}/purchase/${purchaseId}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async bookingCancel(companyid: Number, bookingid: Number, notify: boolean, reason: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,

      };
      const body = {
        "notify": notify,
        "reason": reason
      }

      return await this.http.post(`${environment.apiServer}/company/${companyid}/booking/${bookingid}/cancel`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async updateBooking(companyid: Number, bookingid: Number, booking) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,

      };
      const body = booking

      return await this.http.put(`${environment.apiServer}/company/${companyid}/booking/${bookingid}`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async sendVerificationEmail(token: string, email: string, name: string, reg: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,
      };
      const data = {
        product: 'dorset.hwrc',
        token: `${token}`,
        email: `${email}&&${reg}`,
        manualToken: true,
        name: `${name}`,
        subject: `${"Permit verification code"}`,
      };
      return await this.http.post(`${environment.apiServer}/client/verify-email`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async verifyToken(token: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,
      };
      const data = {
        token: `${token}`,
      };
      return await this.http.post(`${environment.apiServer}/client/verify-token`, data, { headers }).toPromise();
    } catch (error) {
      console.error(error);
      return error;
    }
  }

  async getClientUrl(company: { toString: () => any; }, email: any,) {
    try {

      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,
      };
      return await this.http.get(`${environment.apiServer}/company/${company.toString()}/client/email/${email}`, {
        headers: headers,
      }).toPromise();
    } catch (error) {
      console.error(error);
      return error;
    }
  }

  async getAllBookings(company: { toString: () => any; }, clientId: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,
      };
      return await this.http.get(`${environment.apiServer}/company/${company.toString()}/bookings?client_id=${clientId}`, {
        headers: headers,
      }).toPromise();
    } catch (error) {
      console.error(error);
      return error;
    }
  }

  async getAllNoBookingsCall(url: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,
      };
      return await this.http.get(`${environment.apiServer}` + url, {
        headers: headers,
      }).toPromise();
    } catch (error) {
      console.error(error);
      return error;
    }
  }

}
